(function () {

    var $htmlBody = $("html, body");
    var headerHeight = 0;

    function calcHeaderHeight() {
        if (!$(".header__title").is(":visible")) {
            headerHeight = $(".header").outerHeight(true);
        } else {
            headerHeight = $(".header__top").outerHeight(true) +
                $(".header__title").outerHeight(true);
        }
    }

    function scrollToContent($elem) {
        var id = $elem.parents(".card").attr("id");
        var buttonHeight = $elem.parents(".card").find(".card-header").height();

        calcHeaderHeight();

        var top = $("#" + id).offset().top;

        $htmlBody.animate({
            scrollTop : top - headerHeight + buttonHeight
        }, 700);
    }

    $(".accordion-xlg >.card >.card-header button").on("click", function (e) {
        var $element = $(this);

        if ($element.attr("aria-expanded") === "false") {
            setTimeout(function () {
                scrollToContent($element);
            }, 400);
        }
    });

    // stop bubble up js
    $(".append-download").on("click", function (e) {
        e.stopImmediatePropagation();
    })

    $(".fancybox").fancybox();

})();